// ********* Attachment Category Type Action Types *********

// Get Attachment Category Type list "Read"
export const GET_ATTACHMENT_CATEGORY_TYPE_DATA =
  "GET_ATTACHMENT_CATEGORY_TYPE_DATA";
export const GET_ATTACHMENT_CATEGORY_TYPE_DATA_SUCCESS =
  "GET_ATTACHMENT_CATEGORY_TYPE_DATA_SUCCESS";
export const GET_ATTACHMENT_CATEGORY_TYPE_DATA_FAIL =
  "GET_ATTACHMENT_CATEGORY_TYPE_DATA_FAIL";

// Create New Attachment Category Type "Create"
export const ADD_ATTACHMENT_CATEGORY_TYPE = "ADD_NEW_ATTACHMENT_CATEGORY_TYPE";
export const ADD_ATTACHMENT_CATEGORY_TYPE_SUCCESS =
  "ADD_ATTACHMENT_CATEGORY_TYPE_SUCCESS";
export const ADD_ATTACHMENT_CATEGORY_TYPE_FAIL =
  "ADD_ATTACHMENT_CATEGORY_TYPE_FAIL";

// Update Attachment Category Type "Update"
export const UPDATE_ATTACHMENT_CATEGORY_TYPE =
  "UPDATE_ATTACHMENT_CATEGORY_TYPE";
export const UPDATE_ATTACHMENT_CATEGORY_TYPE_SUCCESS =
  "UPDATE_ATTACHMENT_CATEGORY_TYPE_SUCCESS";
export const UPDATE_ATTACHMENT_CATEGORY_TYPE_FAIL =
  "UPDATE_ATTACHMENT_CATEGORY_TYPE_FAIL";

// Delete Attachment Category Type "Delete"
export const DELETE_ATTACHMENT_CATEGORY_TYPE =
  "DELETE_ATTACHMENT_CATEGORY_TYPE";
export const DELETE_ATTACHMENT_CATEGORY_TYPE_SUCCESS =
  "DELETE_ATTACHMENT_CATEGORY_TYPE_SUCCESS";
export const DELETE_ATTACHMENT_CATEGORY_TYPE_FAIL =
  "DELETE_ATTACHMENT_CATEGORY_TYPE_FAIL";
